// 媒体播放器
export const MEDIA_STATUS_NONE = 0   // 未初始化
export const MEDIA_STATUS_PLAYING = 1 // 播放中
export const MEDIA_STATUS_PAUSED = 2 // 暂停中
export const MEDIA_STATUS_ENDED = 3 // 已结束
